export const azurePermissionsRoutes = [
  {
    path: "/firewall-rules",
    name: "firewall-rules",
    component: () => import(/* webpackChunkName: "azurePermissions" */ "./AzurePermissionsView.vue"),
  },
];
